// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-name {\n  background: none;\n  border: none;\n}\n.tpss {\n  line-height: unset !important;\n}\n.cls-tabs-navs.newPosition .el-tabs__item {\n  transition: all 0.3s;\n  border-bottom: 2px solid transparent;\n}\n.cls-tabs-navs.newPosition .el-tabs__item.is-active {\n    border-bottom: 2px solid #5088ff;\n}\n.cls-tabs-navs.newPosition .el-tabs__active-bar {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
